// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-signup-root {
  min-height: 100vh;
  background: var(--color-bg-root);
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 16px 120px;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
}

.post-signup-card {
  width: min(420px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.post-signup-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.post-signup-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.post-signup-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: var(--color-text-secondary);
}

.post-signup-choices {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.post-signup-choice {
  width: 100%;
  padding: 12px 14px;
  text-align: left;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.post-signup-choice:hover {
  background: var(--color-bg-user-bubble);
}

.post-signup-choice.is-selected {
  border-color: var(--color-accent-base);
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
}

.post-signup-choice-label {
  font-weight: 600;
}

.post-signup-choice-desc {
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.4;
}

.post-signup-choice.is-selected .post-signup-choice-desc {
  color: var(--color-text-on-accent);
  opacity: 0.85;
}

.post-signup-error {
  font-size: 12px;
  color: var(--color-status-error-text);
  background: var(--color-status-error-tint);
  border: 1px solid var(--color-status-error-border);
  padding: 8px 10px;
}

.post-signup-submit {
  padding: 10px 12px;
  border: none;
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  font-family: inherit;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}

.post-signup-submit:disabled {
  opacity: 0.6;
  cursor: default;
}

.post-signup-waiting {
  font-size: 13px;
  color: var(--color-text-secondary);
}

.post-signup-link-btn {
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-family: inherit;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}

.post-signup-link-btn:hover {
  background: var(--color-bg-user-bubble);
}

.post-signup-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.post-signup-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.post-signup-input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-family: inherit;
  font-size: 13px;
}

.post-signup-input:focus {
  outline: none;
  border-color: var(--color-accent-base);
}

.post-signup-hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--color-text-secondary);
}

.post-signup-success {
  font-size: 12px;
  line-height: 1.5;
  color: var(--color-text-secondary);
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  padding: 10px 12px;
}

.post-signup-result {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
}

.post-signup-result-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.post-signup-result-body {
  font-size: 13px;
  line-height: 1.5;
  color: var(--color-text-primary);
}

.post-signup-textarea {
  width: 100%;
  min-height: 132px;
  padding: 12px 14px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-family: inherit;
  font-size: 13px;
  line-height: 1.5;
  resize: vertical;
}

.post-signup-textarea:focus {
  outline: none;
  border-color: var(--color-accent-base);
}

.post-signup-image-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.post-signup-image-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.post-signup-image {
  width: 100%;
  aspect-ratio: 1.3 / 1;
  object-fit: cover;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-root);
}

.post-signup-image-remove {
  padding: 8px 10px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
}

.post-signup-upload-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 12px;
  border: 1px dashed var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.post-signup-file-input {
  display: none;
}

.post-signup-action-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.post-signup-inline-note {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.post-signup-bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  padding: 14px 16px calc(14px + env(safe-area-inset-bottom, 0px));
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    color-mix(in srgb, var(--color-bg-root) 92%, transparent) 28%,
    var(--color-bg-root) 100%
  );
}

.post-signup-bottom-bar-inner {
  width: min(820px, 100%);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--color-border-input);
  background: color-mix(in srgb, var(--color-bg-canvas-surface) 94%, transparent);
  backdrop-filter: blur(12px);
}

.post-signup-bottom-meta {
  font-size: 12px;
  line-height: 1.45;
  color: var(--color-text-secondary);
}

.post-signup-bottom-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.post-signup-card-wide {
  width: min(820px, 100%);
}

.post-signup-card-character-wide {
  width: min(1180px, 100%);
}

.post-signup-bottom-bar-inner-character {
  width: min(1180px, 100%);
}

.post-signup-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 6px;
  border-top: 1px solid var(--color-border-input);
}

.post-signup-section-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.post-signup-section-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.post-signup-section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.post-signup-inline-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
}

.post-signup-competitor-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.post-signup-competitor-card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  cursor: pointer;
  text-align: left;
}

.post-signup-competitor-card.is-selected {
  border-color: var(--color-accent-base);
  background: var(--color-bg-canvas-surface);
}

.post-signup-competitor-avatar {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  object-fit: cover;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-root);
  flex: 0 0 auto;
}

.post-signup-competitor-avatar-fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
}

.post-signup-competitor-copy {
  min-width: 0;
}

.post-signup-competitor-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.post-signup-competitor-meta {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.post-signup-ads-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.post-signup-ad-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  cursor: pointer;
  text-align: left;
}

.post-signup-ad-card.is-selected {
  border-color: var(--color-accent-base);
  box-shadow: inset 0 0 0 1px var(--color-accent-base);
}

.post-signup-ad-video {
  width: 100%;
  aspect-ratio: 16 / 10;
  border: 1px solid var(--color-border-input);
  object-fit: cover;
  background: var(--color-bg-root);
}

.post-signup-ad-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: var(--color-text-secondary);
}

.post-signup-ad-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.post-signup-ad-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.post-signup-ad-text {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 12px;
  line-height: 1.45;
  color: var(--color-text-secondary);
}

.post-signup-ad-select {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-accent-base);
}

.post-signup-character-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.post-signup-character-layout {
  display: grid;
  grid-template-columns: 250px minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

.post-signup-character-sidebar {
  min-width: 0;
}

.post-signup-character-main {
  min-width: 0;
}

.post-signup-character-filter-shell {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 14px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  position: sticky;
  top: 16px;
}

.post-signup-character-search {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 13px;
}

.post-signup-character-search:focus {
  outline: none;
  border-color: var(--color-accent-base);
}

.post-signup-character-filter-groups {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.post-signup-character-filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.post-signup-character-filter-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.7;
}

.post-signup-character-filter-chips,
.post-signup-character-active-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.post-signup-character-filter-chip {
  padding: 5px 10px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font: inherit;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.post-signup-character-filter-chip:hover {
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
}

.post-signup-character-filter-chip.is-active {
  background: var(--color-text-primary);
  border-color: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
}

.post-signup-character-clear {
  padding: 5px 0;
  border: none;
  background: none;
  color: var(--color-text-secondary);
  font: inherit;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  opacity: 0.7;
}

.post-signup-character-clear:hover {
  opacity: 1;
  color: var(--color-text-primary);
}

.post-signup-character-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  cursor: pointer;
  text-align: left;
}

.post-signup-character-card.is-selected {
  border-color: var(--color-accent-base);
  box-shadow: inset 0 0 0 1px var(--color-accent-base);
}

.post-signup-character-image-wrap {
  width: 100%;
  aspect-ratio: 4 / 5;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-root);
  overflow: hidden;
}

.post-signup-character-image,
.post-signup-character-placeholder {
  width: 100%;
  height: 100%;
}

.post-signup-character-image {
  object-fit: cover;
}

.post-signup-character-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text-secondary);
}

.post-signup-character-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.post-signup-character-description {
  font-size: 12px;
  line-height: 1.45;
  color: var(--color-text-secondary);
}

@media (max-width: 720px) {
  .post-signup-card-wide {
    width: 100%;
  }

  .post-signup-inline-form {
    grid-template-columns: 1fr;
  }

  .post-signup-competitor-list,
  .post-signup-ads-grid,
  .post-signup-character-grid,
  .post-signup-image-grid {
    grid-template-columns: 1fr;
  }

  .post-signup-character-layout {
    grid-template-columns: 1fr;
  }

  .post-signup-character-filter-shell {
    position: static;
  }

  .post-signup-action-row {
    flex-direction: column;
    align-items: stretch;
  }

  .post-signup-bottom-bar-inner {
    flex-direction: column;
    align-items: stretch;
  }

  .post-signup-bottom-actions {
    flex-direction: column;
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PostSignupPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,8EAA8E;AAChF;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,0DAA0D;EAC1D,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,kCAAkC;EAClC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;EAC5C,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gEAAgE;EAChE;;;;;GAKC;AACH;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,+EAA+E;EAC/E,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,2CAA2C;EAC3C,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2CAA2C;EAC3C,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,iCAAiC;EACjC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".post-signup-root {\n  min-height: 100vh;\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 16px 120px;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n}\n\n.post-signup-card {\n  width: min(420px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.post-signup-header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.post-signup-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.post-signup-subtitle {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-choices {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.post-signup-choice {\n  width: 100%;\n  padding: 12px 14px;\n  text-align: left;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-family: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.post-signup-choice:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.post-signup-choice.is-selected {\n  border-color: var(--color-accent-base);\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n}\n\n.post-signup-choice-label {\n  font-weight: 600;\n}\n\n.post-signup-choice-desc {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n}\n\n.post-signup-choice.is-selected .post-signup-choice-desc {\n  color: var(--color-text-on-accent);\n  opacity: 0.85;\n}\n\n.post-signup-error {\n  font-size: 12px;\n  color: var(--color-status-error-text);\n  background: var(--color-status-error-tint);\n  border: 1px solid var(--color-status-error-border);\n  padding: 8px 10px;\n}\n\n.post-signup-submit {\n  padding: 10px 12px;\n  border: none;\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  font-family: inherit;\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.post-signup-submit:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.post-signup-waiting {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-link-btn {\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-family: inherit;\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.post-signup-link-btn:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.post-signup-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.post-signup-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-input {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-family: inherit;\n  font-size: 13px;\n}\n\n.post-signup-input:focus {\n  outline: none;\n  border-color: var(--color-accent-base);\n}\n\n.post-signup-hint {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-success {\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  padding: 10px 12px;\n}\n\n.post-signup-result {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n}\n\n.post-signup-result-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-result-body {\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--color-text-primary);\n}\n\n.post-signup-textarea {\n  width: 100%;\n  min-height: 132px;\n  padding: 12px 14px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1.5;\n  resize: vertical;\n}\n\n.post-signup-textarea:focus {\n  outline: none;\n  border-color: var(--color-accent-base);\n}\n\n.post-signup-image-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.post-signup-image-card {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.post-signup-image {\n  width: 100%;\n  aspect-ratio: 1.3 / 1;\n  object-fit: cover;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-root);\n}\n\n.post-signup-image-remove {\n  padding: 8px 10px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-family: inherit;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.post-signup-upload-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 12px;\n  border: 1px dashed var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.post-signup-file-input {\n  display: none;\n}\n\n.post-signup-action-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.post-signup-inline-note {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-bottom-bar {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 20;\n  padding: 14px 16px calc(14px + env(safe-area-inset-bottom, 0px));\n  background: linear-gradient(\n    180deg,\n    rgba(0, 0, 0, 0) 0%,\n    color-mix(in srgb, var(--color-bg-root) 92%, transparent) 28%,\n    var(--color-bg-root) 100%\n  );\n}\n\n.post-signup-bottom-bar-inner {\n  width: min(820px, 100%);\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--color-border-input);\n  background: color-mix(in srgb, var(--color-bg-canvas-surface) 94%, transparent);\n  backdrop-filter: blur(12px);\n}\n\n.post-signup-bottom-meta {\n  font-size: 12px;\n  line-height: 1.45;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-bottom-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.post-signup-card-wide {\n  width: min(820px, 100%);\n}\n\n.post-signup-card-character-wide {\n  width: min(1180px, 100%);\n}\n\n.post-signup-bottom-bar-inner-character {\n  width: min(1180px, 100%);\n}\n\n.post-signup-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-top: 6px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.post-signup-section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.post-signup-section-eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-section-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.post-signup-inline-form {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 10px;\n}\n\n.post-signup-competitor-list {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.post-signup-competitor-card {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  text-align: left;\n}\n\n.post-signup-competitor-card.is-selected {\n  border-color: var(--color-accent-base);\n  background: var(--color-bg-canvas-surface);\n}\n\n.post-signup-competitor-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  object-fit: cover;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-root);\n  flex: 0 0 auto;\n}\n\n.post-signup-competitor-avatar-fallback {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.post-signup-competitor-copy {\n  min-width: 0;\n}\n\n.post-signup-competitor-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.post-signup-competitor-meta {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-ads-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.post-signup-ad-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  text-align: left;\n}\n\n.post-signup-ad-card.is-selected {\n  border-color: var(--color-accent-base);\n  box-shadow: inset 0 0 0 1px var(--color-accent-base);\n}\n\n.post-signup-ad-video {\n  width: 100%;\n  aspect-ratio: 16 / 10;\n  border: 1px solid var(--color-border-input);\n  object-fit: cover;\n  background: var(--color-bg-root);\n}\n\n.post-signup-ad-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-ad-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.post-signup-ad-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.post-signup-ad-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-size: 12px;\n  line-height: 1.45;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-ad-select {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-accent-base);\n}\n\n.post-signup-character-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.post-signup-character-layout {\n  display: grid;\n  grid-template-columns: 250px minmax(0, 1fr);\n  gap: 16px;\n  align-items: start;\n}\n\n.post-signup-character-sidebar {\n  min-width: 0;\n}\n\n.post-signup-character-main {\n  min-width: 0;\n}\n\n.post-signup-character-filter-shell {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 14px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  position: sticky;\n  top: 16px;\n}\n\n.post-signup-character-search {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 13px;\n}\n\n.post-signup-character-search:focus {\n  outline: none;\n  border-color: var(--color-accent-base);\n}\n\n.post-signup-character-filter-groups {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.post-signup-character-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.post-signup-character-filter-label {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  opacity: 0.7;\n}\n\n.post-signup-character-filter-chips,\n.post-signup-character-active-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.post-signup-character-filter-chip {\n  padding: 5px 10px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font: inherit;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n\n.post-signup-character-filter-chip:hover {\n  border-color: var(--color-text-secondary);\n  color: var(--color-text-primary);\n}\n\n.post-signup-character-filter-chip.is-active {\n  background: var(--color-text-primary);\n  border-color: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n}\n\n.post-signup-character-clear {\n  padding: 5px 0;\n  border: none;\n  background: none;\n  color: var(--color-text-secondary);\n  font: inherit;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  opacity: 0.7;\n}\n\n.post-signup-character-clear:hover {\n  opacity: 1;\n  color: var(--color-text-primary);\n}\n\n.post-signup-character-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  text-align: left;\n}\n\n.post-signup-character-card.is-selected {\n  border-color: var(--color-accent-base);\n  box-shadow: inset 0 0 0 1px var(--color-accent-base);\n}\n\n.post-signup-character-image-wrap {\n  width: 100%;\n  aspect-ratio: 4 / 5;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-root);\n  overflow: hidden;\n}\n\n.post-signup-character-image,\n.post-signup-character-placeholder {\n  width: 100%;\n  height: 100%;\n}\n\n.post-signup-character-image {\n  object-fit: cover;\n}\n\n.post-signup-character-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--color-text-secondary);\n}\n\n.post-signup-character-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.post-signup-character-description {\n  font-size: 12px;\n  line-height: 1.45;\n  color: var(--color-text-secondary);\n}\n\n@media (max-width: 720px) {\n  .post-signup-card-wide {\n    width: 100%;\n  }\n\n  .post-signup-inline-form {\n    grid-template-columns: 1fr;\n  }\n\n  .post-signup-competitor-list,\n  .post-signup-ads-grid,\n  .post-signup-character-grid,\n  .post-signup-image-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .post-signup-character-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .post-signup-character-filter-shell {\n    position: static;\n  }\n\n  .post-signup-action-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .post-signup-bottom-bar-inner {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .post-signup-bottom-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
